import React, { useEffect, useMemo, useState } from 'react';
import { IScreen } from 'type';
import { Button, CMSLayout, Col, Grid, Input, Row, showPopupMessage, Text, useUIState } from 'components';
import Store from 'store';
import apiClient from 'store/api-client';
import { RangeDatePicker } from 'components/elements/form';
import { COLOR, SCREEN } from 'const';
import dayjs from 'dayjs';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import { Result } from 'antd';
import Select from '../../components/elements/form/Select';
var { Liquid } = require('liquidjs');
var engine = new Liquid();

const LIQUID_TEMPLATE = `
<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en" lang="en">
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
  <style type="text/css">
    * {
      margin: 0;
      padding: 0;
      text-indent: 0;
    }
    body {
      padding: 12px;
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      width: {{ viewWidth }};
      height: {{ viewHeight }};
    }
    .logo {
      margin-left: 8pt;
    }
    .header-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    .normal-text {
      text-indent: 0pt;
      line-height: 11pt;
      text-align: left;
    }
    .row {
      display: flex;
      flex-direction: row;
    }
    p {
      color: black;
      font-family: Calibri, sans-serif;
      font-style: normal;
      font-weight: normal;
      text-decoration: none;
      font-size: 9pt;
      margin: 0pt;
    }
    .s1 {
      color: black;
      font-family: Calibri, sans-serif;
      font-style: normal;
      font-weight: normal;
      text-decoration: none;
      font-size: 24pt;
    }
    .s2 {
      color: black;
      font-family: Calibri, sans-serif;
      font-style: normal;
      font-weight: bold;
      text-decoration: none;
      font-size: 9pt;
    }
    .s3 {
      color: black;
      font-family: Calibri, sans-serif;
      font-style: normal;
      font-weight: normal;
      text-decoration: none;
      font-size: 9pt;
    }
    .s5 {
      color: #333;
      font-family: Calibri, sans-serif;
      font-style: normal;
      font-weight: normal;
      text-decoration: none;
      font-size: 8pt;
    }
    .main-content {
      display: block;
      margin-top: 16pt;
    }
    .total-container {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
    .devider {
      height: 1px;
      background-color: black;
      width: 250pt;
      margin-top: 8pt;
      margin-bottom: 8pt;
    }
    h1 {
      color: black;
      font-family: Calibri, sans-serif;
      font-style: normal;
      font-weight: bold;
      text-decoration: none;
      font-size: 10.5pt;
    }
    h2 {
      color: black;
      font-family: Calibri, sans-serif;
      font-style: normal;
      font-weight: bold;
      text-decoration: none;
      font-size: 10pt;
    }
    .muted { color: #666; }
    .box { border: 1px solid #ddd; border-radius: 6px; padding: 10px; margin-top: 12px; }
    table { border-collapse: collapse; width: 100%; }
    th, td { border-bottom: 1px solid #ddd; padding: 6px 4px; font-size: 9pt; }
    th { text-align: left; }
    .num { text-align: right; white-space: nowrap; }
    .totals { margin-top: 10px; display: flex; justify-content: flex-end; }
    .totals table { width: 240px; }
    .totals td { border: none; padding: 4px; }
    .hr { height: 1px; background: #000; opacity: 0.15; margin: 10px 0; }
    .separator {
      width: 100%;
      height: 13px;
      margin-top: 6pt;
      margin-bottom: 6pt;
      background: linear-gradient(to right, #111 0%, #111 30%, rgba(17,17,17,0.15) 30%, rgba(17,17,17,0.15) 100%);
      opacity: 0.35;
    }
    .keep-together {
      page-break-inside: avoid;
      break-inside: avoid;
    }
    table,
    tbody {
      vertical-align: top;
      overflow: visible;
    }
    body {
      box-sizing: border-box;
    }
    @media screen {
      body {
        padding: 40px;
      }
    }
  </style>
</head>
<body>
  <div class="header-container">
    <div>
      <img src="https://print-manager-media.s3.eu-west-1.amazonaws.com/bg/invoice_logo_cropped.png" style="height: 120px; width: auto; " />
      <p class="s1" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">PERIOD INVOICE</p>
    </div>
    <div class="row">
      <div style="margin-right: 12px; min-width: 150px">
        <h2 style="padding-top: 3pt;" class="normal-text">Period</h2>
        <p class="normal-text">{{ period.from }} - {{ period.to }}</p>
        <h2 style="padding-top: 6pt;" class="normal-text">Generated</h2>
        <p class="normal-text">{{ period.generatedAt }}</p>
        <h2 style="padding-top: 6pt;" class="normal-text">Invoices</h2>
        <p class="normal-text">{{ totals.count }}</p>
        <h2 style="padding-top: 6pt;" class="normal-text">VAT Number</h2>
        <p class="normal-text">{{ company.vatNumber }}</p>
      </div>
      <div style="margin-right: 12px; min-width: 150px">
        <p style="padding-top: 4pt;padding-left: 5pt;text-indent: 0pt;line-height: 118%;text-align: left;">{{ company.addressHtml }}</p>
      </div>
    </div>
  </div>

  <p><br /></p>
  <div class="main-content">
    <table style="border-collapse:collapse; table-layout: fixed; width: 100%;" cellspacing="0">
      <tr style="height:16pt">
        <td style="width:70pt;border-bottom-style:solid;border-bottom-width:1pt">
          <p class="s2" style="padding-left: 2pt;text-indent: 0pt;line-height: 9pt;text-align: left;">Invoice ID</p>
        </td>
        <td style="width:85pt;border-bottom-style:solid;border-bottom-width:1pt">
          <p class="s2" style="padding-right: 2pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Order</p>
        </td>
        <td style="width:75pt;border-bottom-style:solid;border-bottom-width:1pt">
          <p class="s2" style="padding-right: 2pt;text-indent: 0pt;line-height: 9pt;text-align: center;">Date</p>
        </td>
        <td style="width:55pt;border-bottom-style:solid;border-bottom-width:1pt">
          <p class="s2" style="padding-right: 2pt;text-indent: 0pt;line-height: 9pt;text-align: center;">VAT</p>
        </td>
        <td style="width:65pt;border-bottom-style:solid;border-bottom-width:1pt">
          <p class="s2" style="padding-right: 2pt;text-indent: 0pt;line-height: 9pt;text-align: right;">Total GBP</p>
        </td>
      </tr>
      {% for row in rows %}
        <tr style="height:33pt">
          <td
            style="width:70pt;border-top-style:solid;border-top-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-bottom-color:#CCCCCC">
            <p class="s3" style="padding-top: 4pt;padding-left: 2pt;padding-right: 2pt;text-indent: 0pt;text-align: left; word-break: break-all;">
              {{ row.invoiceId }}
            </p>
          </td>
          <td
            style="width:85pt;border-top-style:solid;border-top-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-bottom-color:#CCCCCC">
            <p class="s3" style="padding-top: 4pt;padding-right: 2pt;text-indent: 0pt;text-align: center;">
            {{ row.orderId }}
            </p>
          </td>
          <td
            style="width:75pt;border-top-style:solid;border-top-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-bottom-color:#CCCCCC">
            <p class="s3" style="padding-top: 4pt;padding-right: 2pt;text-indent: 0pt;text-align: center;">
            {{ row.invoiceDate }}
            </p>
          </td>
          <td
            style="width:55pt;border-top-style:solid;border-top-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-bottom-color:#CCCCCC">
            <p class="s3" style="padding-top: 4pt;padding-right: 2pt;text-indent: 0pt;text-align: center;">
            {{ row.vatTotal }}
            </p>
          </td>
          <td
            style="width:65pt;border-top-style:solid;border-top-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-bottom-color:#CCCCCC">
            <p class="s3" style="padding-top: 4pt;padding-right: 2pt;text-indent: 0pt;text-align: right;">
            {{ row.total }}
            </p>
          </td>
        </tr>
      {% endfor %}
    </table>
    <p style="text-indent: 0pt;text-align: left;"><br /></p>

    <div class="total-container" style="padding-right: 2pt;">
      <div class="row">
        <p class="normal-text">TOTAL VAT</p>
        <p style="width: 80pt; text-align: right">{{ totals.vatTotal }}</p>
      </div>
      <div class="devider"></div>
      <div class="row">
        <p class="normal-text" style="font-weight: bold;">TOTAL GBP</p>
        <p style="width: 80pt; text-align: right; font-weight: bold;">{{ totals.grandTotal }}</p>
      </div>
    </div>

    <h1 style="padding-top: 33pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Due Date: {{ dueDate }}</h1>
    <p style="padding-left: 5pt;text-indent: 0pt;text-align: left;">
      Invoices can be paid to Proper Goose Ltd via BACS. Account number- 35327168 Sort code- 30-65-41
    </p>
  </div>

  <div class="keep-together">
    <img width="100%" height="13"
      src="data:image/png;base64,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" />
    <div class="header-container" style="margin-top: 5pt;">
    <div>
      <p class="s1" style="padding-left: 8pt;text-indent: 0pt;text-align: left;">PAYMENT ADVICE</p>
      <p style="padding-top: 24pt;padding-left: 53pt;text-indent: -17pt;line-height: 118%;text-align: left;">To: {{ billingAddress }}</p>
      <p style="text-indent: 0pt;text-align: left;"><br /></p>
    </div>
    <div>
      <div class="row">
        <p class="normal-text" style="font-weight: bold; width: 90pt">Reseller</p>
        <p>{{ resellerName }}</p>
      </div>
      <div class="row">
        <p class="normal-text" style="font-weight: bold; width: 90pt">Invoice Number</p>
        <p>{{ invoiceNumber }}</p>
      </div>
      <div class="devider" style="background-color: gray;"></div>
      <div class="row">
        <p class="normal-text" style="font-weight: bold; width: 90pt">Amount Due</p>
        <p style="font-weight: bold;">{{ amountDue }}</p>
      </div>
      <div class="row">
        <p class="normal-text" style="font-weight: bold; width: 90pt">Due Date </p>
        <p>{{ dueDate }}</p>
      </div>
      <div class="devider" style="background-color: gray;"></div>
      <h2 class="normal-text" style="font-weight: bold;">Amount Enclosed</h2>
      <div class="devider"></div>
      <p class="s5" style="padding-top: 3pt;padding-left: 104pt;text-indent: 0pt;text-align: left;">Enter the amount you are paying above</p>
    </div>
  </div>
    <p style="text-indent: 0pt;text-align: left; padding-top: 10pt; font-size: 7pt;">Company Registration No: 09119257. Registered Office: Attention: Nicola Parr, 85 Island Farm Road, West Molesey, Surrey, KT8 2LN, United Kingdom</p>
  </div>
</body>
</html>
`;

const PeriodInvoice: IScreen = () => {
  const UserStore = Store.useUserStore();
  const [{ loading }, setUI] = useUIState({ loading: false });
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [listResellers, setListResellers] = useState<Array<{ label: string; value: string }>>([
    { label: 'All resellers', value: 'all' },
  ]);
  const [selectedReseller, setSelectedReseller] = useState<{ label: string; value: string }>({
    label: 'All resellers',
    value: 'all',
  });
  const [dataForm, setDataForm] = useState<any>(() => ({
    invoiceNumber: '',
    vatNumber: '196504680',
    companyName: 'Proper Goose Ltd',
    bgAddress1: '85 Island Farm Road',
    bgAddress2: 'West Molesey',
    bgZipCode: 'KT8 2LN',
    bgPhoneNumber: '020 8941 3481',
    resellerName: '',
    resellerAddress1: '',
    resellerAddress2: '',
    resellerTown: '',
    resellerPostCode: '',
    resellerCountry: '',
    invoiceDate: new Date(),
    dueDate: new Date(),
  }));
  const [range, setRange] = useState(() => ({
    startDate: dayjs().startOf('month').toDate(),
    endDate: dayjs().endOf('month').toDate(),
  }));

  const canUse = useMemo(() => UserStore.user?.role === 'admin', [UserStore.user?.role]);
  const isAdmin = canUse;

  useEffect(() => {
    (async () => {
      if (!isAdmin) return;
      try {
        const { list } = await UserStore.getListResellers(1);
        const options = [
          { label: 'All resellers', value: 'all' },
          ...(list || []).map((v: any) => ({
            label: [v.firstName, v.lastName].filter(Boolean).join(' ') || v.email || v.id,
            value: v.id,
          })),
        ];
        setListResellers(options);
      } catch (err) {
        // ignore
      }
    })();
  }, [isAdmin]);

  useEffect(() => {
    if (!isAdmin) return;
    if (!selectedReseller?.value || selectedReseller.value === 'all') return;
    const reseller: any = (UserStore as any)?.users?.[selectedReseller.value];
    if (!reseller) return;
    const displayName = [reseller.firstName, reseller.lastName].filter(Boolean).join(' ')
      || reseller.accountName
      || reseller.email
      || reseller.id;
    setDataForm((prev: any) => ({
      ...prev,
      resellerName: displayName,
      resellerAddress1: reseller.addressLine1 || '',
      resellerAddress2: reseller.addressLine2 || '',
      resellerTown: reseller.town || '',
      resellerPostCode: reseller.postCode || '',
      resellerCountry: reseller.country || '',
    }));
  }, [isAdmin, selectedReseller?.value]);

  const formatMoney = (v: any) => {
    const n = Number(v);
    if (!Number.isFinite(n)) return '0.00';
    return n.toFixed(2);
  };

  const buildSummaryRow = (inv: any) => {
    const createdAt = inv?.createdAt ? dayjs(inv.createdAt) : null;
    const invoiceDate = createdAt && createdAt.isValid() ? createdAt.format('DD-MM-YYYY') : '';
    const vatTotal = inv?.taxes != null ? formatMoney(inv.taxes) : '0.00';
    const total = inv?.total != null ? formatMoney(inv.total) : '0.00';
    return {
      invoiceId: inv?.id || '',
      orderId: inv?.orderId || '',
      invoiceDate,
      vatTotal,
      total,
    };
  };

  const onChangeField = (label: string) => (newValue: any) => {
    setDataForm((prev: any) => ({ ...prev, [label]: newValue }));
  };

  const onGenerate = async () => {
    if (!canUse) {
      showPopupMessage({
        title: '',
        content: 'Permission denied',
        buttonOkText: 'OK',
        typeHighlight: 'danger',
        contentHighlight: 'Error',
      });
      return;
    }
    if (!range?.startDate || !range?.endDate) {
      showPopupMessage({
        title: '',
        content: 'Please select both start and end dates.',
        buttonOkText: 'OK',
        typeHighlight: 'danger',
        contentHighlight: 'Invalid date range',
      });
      return;
    }

    const fromDate = dayjs(range.startDate).format('YYYY-MM-DD');
    const toDate = dayjs(range.endDate).format('YYYY-MM-DD');
    const defaultInvoiceNumber = `PERIOD-${fromDate}-${toDate}`;

    setUI({ loading: true });
    try {
      const resellerId =
        selectedReseller?.value && selectedReseller.value !== 'all'
          ? selectedReseller.value
          : undefined;

      const query: any = { fromDate, toDate };
      if (resellerId) query.resellerId = resellerId;
      const res = await apiClient.Api.Order.periodInvoices(query);
      const invoices = res?.data?.invoices || [];
      if (!invoices.length) {
        showPopupMessage({
          title: '',
          content: 'No invoices found for the selected period.',
          buttonOkText: 'OK',
          typeHighlight: 'danger',
          contentHighlight: 'Empty',
        });
        return;
      }

      const vatTotal = formatMoney(invoices.reduce((acc, x) => acc + Number(x?.taxes || 0), 0));
      const grandTotal = formatMoney(invoices.reduce((acc, x) => acc + Number(x?.total || 0), 0));

      const html = await engine.parseAndRender(LIQUID_TEMPLATE, {
        viewWidth: '100%',
        viewHeight: '100%',
        company: {
          addressHtml: [
            dataForm.companyName,
            dataForm.bgAddress1,
            dataForm.bgAddress2,
            dataForm.bgZipCode,
            dataForm.bgPhoneNumber,
          ].filter(Boolean).join('<br />'),
          vatNumber: dataForm.vatNumber || '196504680',
        },
        period: {
          from: dayjs(fromDate).format('DD-MM-YYYY'),
          to: dayjs(toDate).format('DD-MM-YYYY'),
          generatedAt: dayjs().format('DD-MM-YYYY HH:mm'),
        },
        resellerName: (dataForm.resellerName || '').trim(),
        billingAddress: [
          dataForm.resellerAddress1,
          dataForm.resellerAddress2,
          dataForm.resellerTown,
          dataForm.resellerPostCode,
          dataForm.resellerCountry,
        ].filter(Boolean).join('<br />'),
        invoiceNumber: (dataForm.invoiceNumber || defaultInvoiceNumber).trim(),
        amountDue: grandTotal,
        dueDate: (() => {
          const d = dataForm.dueDate;
          if (d instanceof Date && !isNaN(d.getTime())) return dayjs(d).format('DD-MM-YYYY HH:mm');
          return dayjs(toDate).format('DD-MM-YYYY');
        })(),
        rows: invoices
          .map(buildSummaryRow)
          .sort((a, b) => (a.invoiceDate || '').localeCompare(b.invoiceDate || '')),
        totals: {
          count: invoices.length,
          vatTotal,
          grandTotal,
        }
      });

      const pdf = await axios.request({
        url: "https://puppeteer.personify.tech/api/html2pdf",
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        data: {
          html,
          viewport: { width: 595, height: 842 },
          returnUrl: true,
        }
      });
      if (pdf?.data?.data) {
        setPdfUrl(pdf.data.data);
      } else {
        throw new Error('Failed to generate PDF');
      }
    } catch (err) {
      showPopupMessage({
        title: '',
        content: String(err),
        buttonOkText: 'OK',
        typeHighlight: 'danger',
        contentHighlight: 'Error',
      });
    } finally {
      setUI({ loading: false });
    }
  };

  return (
    <CMSLayout requireAuthen breadcrumbs={[{ title: 'Period Invoice', screen: SCREEN.PeriodInvoice }]}>
      {pdfUrl ? (
        <Result
          status="success"
          title="Successfully generated period invoices"
          subTitle="You can download the PDF file below"
          extra={
            // @ts-ignore
            <Row flex1 alignContent={"center"} justifyContent={"center"} style={{ gap: 10 }}>
              <Button text='Download PDF' onPress={() => window.open(pdfUrl, '_blank')} />
              <Button
                text="Create new"
                outline
                onPress={() => {
                  setPdfUrl(null);
                }}
              />
            </Row>
          }
        />
      ) : (
        <>
          <Row m2 marginBottom={0} justifyContent={'space-between'}>
            <Text h3>Period Invoice</Text>
          </Row>

          <Col flex1 m2 mv1 p1 round1 bgWhite overflow={"scroll"}>
            <Grid xs="100%" md="50%" alignItems={"flex-start"} mb2>
              <Col m1>
                <Text subtitle1 mb2>
                  Invoice Information
                </Text>

                {isAdmin && (
                  <>
                    <Text mb0 caption>Reseller</Text>
                    <Select
                      innerProps={{ placeholder: "All resellers" }}
                      value={selectedReseller}
                      onChange={setSelectedReseller}
                      round0
                      borderThin
                      height={45}
                      noBorder
                      overflow="hidden"
                      options={listResellers}
                      mb1
                    />
                  </>
                )}

                <Text mb0 caption>Invoice Number</Text>
                <Input
                  placeholder="Invoice Number"
                  value={dataForm.invoiceNumber || ""}
                  inputProps={{ placeholderTextColor: COLOR.GREY }}
                  mb1
                  onChange={onChangeField("invoiceNumber")}
                />

                <Text mb0 caption>VAT Number</Text>
                <Input
                  placeholder="VAT Number"
                  value={dataForm.vatNumber || ""}
                  inputProps={{ placeholderTextColor: COLOR.GREY }}
                  mb1
                  onChange={onChangeField("vatNumber")}
                />

                <Text mb0 caption>Company Name</Text>
                <Input
                  placeholder="Proper Goose Ltd"
                  value={dataForm.companyName || ""}
                  inputProps={{ placeholderTextColor: COLOR.GREY }}
                  mb1
                  onChange={onChangeField("companyName")}
                />

                <Text mb0 caption>BG Address 1</Text>
                <Input
                  placeholder="BG Address 1"
                  value={dataForm.bgAddress1 || ""}
                  inputProps={{ placeholderTextColor: COLOR.GREY }}
                  mb1
                  onChange={onChangeField("bgAddress1")}
                />
                <Text mb0 caption>BG Address 2</Text>
                <Input
                  placeholder="BG Address 2"
                  value={dataForm.bgAddress2 || ""}
                  inputProps={{ placeholderTextColor: COLOR.GREY }}
                  mb1
                  onChange={onChangeField("bgAddress2")}
                />
                <Text mb0 caption>BG ZIP Code</Text>
                <Input
                  placeholder="BG ZIP Code"
                  value={dataForm.bgZipCode || ""}
                  inputProps={{ placeholderTextColor: COLOR.GREY }}
                  mb1
                  onChange={onChangeField("bgZipCode")}
                />
                <Text mb0 caption>BG Phone Number</Text>
                <Input
                  placeholder="BG Phone Number"
                  value={dataForm.bgPhoneNumber || ""}
                  inputProps={{ placeholderTextColor: COLOR.GREY }}
                  mb1
                  onChange={onChangeField("bgPhoneNumber")}
                />

                <Text mb0 caption>Reseller Name</Text>
                <Input
                  placeholder="Reseller Name"
                  value={dataForm.resellerName || ""}
                  inputProps={{ placeholderTextColor: COLOR.GREY }}
                  mb1
                  onChange={onChangeField("resellerName")}
                />

                <Text mb0 caption>Reseller Address 1</Text>
                <Input
                  placeholder="Reseller Address 1"
                  value={dataForm.resellerAddress1 || ""}
                  inputProps={{ placeholderTextColor: COLOR.GREY }}
                  mb1
                  onChange={onChangeField("resellerAddress1")}
                />
                <Text mb0 caption>Reseller Address 2</Text>
                <Input
                  placeholder="Reseller Address 2"
                  value={dataForm.resellerAddress2 || ""}
                  inputProps={{ placeholderTextColor: COLOR.GREY }}
                  mb1
                  onChange={onChangeField("resellerAddress2")}
                />
                <Text mb0 caption>Reseller Town/City</Text>
                <Input
                  placeholder="Reseller Town/City"
                  value={dataForm.resellerTown || ""}
                  inputProps={{ placeholderTextColor: COLOR.GREY }}
                  mb1
                  onChange={onChangeField("resellerTown")}
                />
                <Text mb0 caption>Reseller Post Code</Text>
                <Input
                  placeholder="Reseller Post Code"
                  value={dataForm.resellerPostCode || ""}
                  inputProps={{ placeholderTextColor: COLOR.GREY }}
                  mb1
                  onChange={onChangeField("resellerPostCode")}
                />
                <Text mb0 caption>Reseller Country</Text>
                <Input
                  placeholder="Reseller Country"
                  value={dataForm.resellerCountry || ""}
                  inputProps={{ placeholderTextColor: COLOR.GREY }}
                  mb1
                  onChange={onChangeField("resellerCountry")}
                />

                <Text mb0 caption>Invoice Date</Text>
                <DatePicker
                  selected={dataForm?.invoiceDate}
                  onChange={onChangeField("invoiceDate")}
                  showTimeSelect
                  customInput={<Input mb1 />}
                  dateFormat="dd/MM/yyyy HH:mm aa"
                />

                <Text mb0 caption>Due Date</Text>
                <DatePicker
                  selected={dataForm?.dueDate}
                  customInput={<Input mb1 />}
                  onChange={onChangeField("dueDate")}
                  showTimeSelect
                  dateFormat="dd/MM/yyyy HH:mm aa"
                />
              </Col>

              <Col m1>
                <Text subtitle1 mb2>Period</Text>
                <RangeDatePicker value={range} onChange={setRange} />

                <Row mt2>
                  <Button
                    text="Create"
                    height={40}
                    width={200}
                    borderRadius={20}
                    onPress={onGenerate}
                    isLoading={loading}
                    disabled={loading}
                  />
                </Row>
              </Col>
            </Grid>

            {!canUse && (
              <Col mt2>
                <Text color="red">Only admins can use this page.</Text>
              </Col>
            )}
          </Col>
        </>
      )}
    </CMSLayout>
  );
};

PeriodInvoice.routeInfo = {
  title: 'Period Invoice',
  path: '/period-invoice',
};

export default PeriodInvoice;

